import { getAlert } from "./SamuiUtils";
import { getData, getDataWithComp } from "./SamuiUtils";
import Axios from "axios";

// เรียกรายงาน Crystal Report
const numberToCurrencyText = async (number, currency) => {
  const res = await fetch("/api/number2currency", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Number: number,
      Currency: currency,
      Lang: "ENG",
    }),
  });

  const text = await res.text(); // แปลงเป็น text ก่อน
  // console.debug("🧾 raw API response:", text);

  let data;
  try {
    data = JSON.parse(text);
  } catch (e) {
    console.error("❌ JSON parse error:", e);
    return "ต้นฉบับ";
  }

  return data?.Result?.Text || "ต้นฉบับ";
};

const getReport = async (reportName, docNo) => {
  console.debug("Generating report:", reportName, docNo);
  try {
    if (!reportName || !docNo) {
      getAlert("FAILED", "ไม่สามารถเปิดรายงานได้ กรุณาลองใหม่อีกครั้ง");
      return;
    }

    let tableMap = {};

    if (
      process.env.REACT_APP_API_REPORT_URL ===
      "https://reporting.appsystemyou.com/api/reports/samui/uat"
    ) {
      tableMap = {
        depos: {
          table: "DEPOS_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบมัดจำ
        pr: { table: "PR_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบขอซื้อ
        po: { table: "PO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบสั่งซื้อ
        rec: { table: "REC_H", filterColumn: "Rec_No", resultColumn: "Rec_Id" }, // ใบรับสินค้า
        pay: { table: "PAY_H", filterColumn: "Pay_No", resultColumn: "Pay_Id" }, // ใบสำคัญจ่าย
        so: { table: "SO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบขาย
        so_receipt: {
          table: "SO_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบเสร็จรับเงิน (ใบขาย)
        bi1: { table: "BL_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบวางบิล (ต้นฉบับ)
        bi2: { table: "BL_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบวางบิล (สำเนา)
        inv_water_receipt: {
          table: "BL_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบเสร็จรับเงิน (ใบวางบิล)
        inv1: {
          table: "INV_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบกำกับภาษี (ต้นฉบับ)
        inv2: {
          table: "INV_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        TAX: {
          table: "API_1702_WTAX_D",
          filterColumn: "WTAX_Id",
          resultColumn: "WTAX_Id",
        }, // ใบกำกับภาษี (ไม่ชำระ)
        CR: { table: "CR_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบลดหนี้
        QT_REV: { table: "QT_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบเสนอราคา (แก้ไข)
      };
    } else {
      tableMap = {
        depos: {
          table: "DEPOS_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบมัดจำ
        pr: { table: "PR_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบขอซื้อ
        po: { table: "PO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        PO_IN: {
          table: "PO_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        PO_OUT: {
          table: "PO_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบสั่งซื้อ
        rec: { table: "REC_H", filterColumn: "Rec_No", resultColumn: "Rec_Id" }, // ใบรับสินค้า
        pay: { table: "PAY_H", filterColumn: "Pay_No", resultColumn: "Pay_Id" }, // ใบสำคัญจ่าย
        PAY_CASH: {
          table: "PAY_H",
          filterColumn: "Pay_No",
          resultColumn: "Pay_Id",
        }, // ใบสำคัญจ่าย
        PAY_CHEQUE: {
          table: "PAY_H",
          filterColumn: "Pay_No",
          resultColumn: "Pay_Id",
        }, // ใบสำคัญจ่าย
        qt: { table: "QT_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบเสนอราคา
        so: { table: "SO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบขาย
        so_receipt: {
          table: "SO_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบเสร็จรับเงิน (ใบขาย)
        // pklist: { table: 'PKList_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },       // ใบ Picking List
        rc: { table: "SO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบสลิป
        bi1: { table: "BL_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบวางบิล (ต้นฉบับ)
        bi2: { table: "BL_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบวางบิล (สำเนา)
        bi_r: {
          table: "INV_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบวางบิล (กระดาษต่อเนื่อง)
        inv1: {
          table: "INV_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบกำกับภาษี (ต้นฉบับ)
        inv2: {
          table: "INV_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        INV_RECEIPT: {
          table: "BL_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบกำกับภาษี (สำเนา)
        ib: {
          table: "WHDoc_Id",
          filterColumn: "WHDoc_No",
          resultColumn: "WHDoc_Id",
        }, // ใบยืมสินค้า
        TAX: {
          table: "API_1702_WTAX_D",
          filterColumn: "WTAX_Id",
          resultColumn: "WTAX_Id",
        }, // ใบหักภาษี ณ ที่จ่าย
        bl_repeat: {
          table: "BL_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        }, // ใบวางบิล (กระดาษต่อเนื่อง)
        WHDOC: {
          table: "WHDoc_H",
          filterColumn: "WHDoc_No",
          resultColumn: "WHDoc_Id",
          typeColumn: "WHDoc_type",
        },
        RCV_CASH: {
          table: "RCV_H",
          filterColumn: "Rcv_No",
          resultColumn: "Rcv_Id",
        }, // ใบสำคัญรับ (เงินสด)
        RCV_CHEQUE: {
          table: "RCV_H",
          filterColumn: "Rcv_No",
          resultColumn: "Rcv_Id",
        }, // ใบสำคัญรับ (เช็ค)
        CR: { table: "CR_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบลดหนี้
        DR: { table: "DR_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบเบิกสินค้า
        QT_REV: { table: "QT_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" }, // ใบเสนอราคา (ต้นฉบับ)

      };
    }

    const reportConfig = tableMap[reportName];
    if (!reportConfig) {
      console.log("Report config not found for:", reportName);
      getAlert("FAILED", "ไม่พบรายงานที่ต้องการ");
      return;
    }

    let pDocId = null;

    if (reportName === "tax") {
      pDocId = docNo;
    } else {
      const { table, filterColumn, resultColumn } = reportConfig;
      const findDocId = await getDataWithComp(
        table,
        `AND ${filterColumn} = '${docNo}'`
      );
      pDocId = findDocId[0]?.[resultColumn];
    }

    if (!pDocId) {
      getAlert("FAILED", "ไม่พบข้อมูลที่ต้องการ");
      return;
    }

    const link = document.createElement("a");
    let pCondition = "ต้นฉบับ";

    if (reportName === "qt") {
      const result = await getDataWithComp(
        "API_0601_QT_H",
        `AND Doc_No = '${docNo}'`
      );
      const netTotal = result[0]?.NetTotal || 0;
      await Axios.post(
        "/api/memo2text",
        {
          Comp_name: "ENCOT",
          Comp_id: parseInt(localStorage.getItem("company"), 10),
          Prod_uat: process.env.REACT_APP_PROD_UAT,
          Doc_type: "QT",
          Doc_no: docNo,
          Status: "Print",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      // const currency = result[0]?.console.debug("💰 NetTotal:", netTotal);
      pCondition = await numberToCurrencyText(netTotal, "THB");
    } else if (reportName === "PO_OUT") {
      const result = await getData(
        "View_PO_NetTotal_Detail",
        `Doc_No = '${docNo}'`
      );
      console.debug("result", result);

      const result2 = await getDataWithComp("PO_H", `AND Doc_No = '${docNo}'`);

      const netTotal = result[0]?.NetTotal || 0;
      const currency = result2[0]?.Doc_Currency || "THB";
      pCondition = await numberToCurrencyText(netTotal, currency);
      await Axios.post(
        "/api/memo2text",
        {
          Comp_name: "ENCOT",
          Comp_id: parseInt(localStorage.getItem("company"), 10),
          Prod_uat: process.env.REACT_APP_PROD_UAT,
          Doc_type: "PO",
          Doc_no: docNo,
          Status: "Print",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
    }

    if (reportName === "bi1" || reportName === "bi2") {
      link.href = `${process.env.REACT_APP_API_REPORT_URL
        }/bi?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === "bi1" ? "ต้นฉบับ" : "สำเนา"
        }`;
    } else if (reportName === "inv1" || reportName === "inv2") {
      if (window.localStorage.getItem("company") === "1") {
        link.href = `${process.env.REACT_APP_API_REPORT_URL
          }/inv_water?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === "inv1" ? "1" : "2"
          }`;
      } else {
        link.href = `${process.env.REACT_APP_API_REPORT_URL
          }/inv?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === "inv1" ? "ต้นฉบับ" : "สำเนา"
          }`;
      }
    } else if (reportName === "WHDOC") {
      const result = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_No = '${docNo}'`
      );
      pDocId = result[0]?.WHDoc_Id;
      pCondition = result[0]?.WHDoc_type || "1";

      link.href = `${process.env.REACT_APP_API_REPORT_URL}/${reportName}?P_DOC_ID=${pDocId}&P_CONDITION=${pCondition}`;
    } else {
      link.href = `${process.env.REACT_APP_API_REPORT_URL
        }/${reportName}?P_DOC_ID=${pDocId}&P_CONDITION=${encodeURIComponent(
          pCondition
        )}`;
    }

    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.click();
  } catch (error) {
    console.error("Error fetching data:", error);
    getAlert("FAILED", error.message || error);
  }
};

export { getReport };
